import { render, staticRenderFns } from "./ShowSubjectsPage.vue?vue&type=template&id=6ca197ad&scoped=true&"
import script from "./ShowSubjectsPage.vue?vue&type=script&lang=js&"
export * from "./ShowSubjectsPage.vue?vue&type=script&lang=js&"
import style0 from "./ShowSubjectsPage.vue?vue&type=style&index=0&id=6ca197ad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca197ad",
  null
  
)

export default component.exports